module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0114.jpg?v=b508f46f";